import { render } from "./IDRList.vue?vue&type=template&id=7ba27517&scoped=true"
import script from "./IDRList.vue?vue&type=script&lang=js"
export * from "./IDRList.vue?vue&type=script&lang=js"

import "./IDRList.vue?vue&type=style&index=0&id=7ba27517&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba27517"]])

export default __exports__